import { resolvePlayAudio } from '../src/adapters/ui/hooks/useAudio';
import type { SoundType } from '../services/audioService';

export function playUiSfx(sound: SoundType): void {
  resolvePlayAudio({ type: 'sfx', sound });
}